import { render, staticRenderFns } from "./TheChatTextarea.vue?vue&type=template&id=0b079ea2&scoped=true"
import script from "./TheChatTextarea.vue?vue&type=script&lang=js"
export * from "./TheChatTextarea.vue?vue&type=script&lang=js"
import style0 from "./TheChatTextarea.vue?vue&type=style&index=0&id=0b079ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b079ea2",
  null
  
)

export default component.exports